import ValidateGlobal from './../ValidateGlobal.js'
import ServiceGlobal from './../InputsServiceGlobal.js'
export default {
  mixins: [ValidateGlobal, ServiceGlobal],
  props: {
    config: {
      type: Object
    },
    modelProps: {
      type: String
    },
    rootModel: {
      type: Object
    },
    parent: {
      type: Object
    },
    originModel: {
      type: String
    }
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  data () {
    return {
      value: this.modelProps
    }
  },
  created () {},
  watch: {
    value () {
      this.$emit('input', this.value)
    }
  },
  computed: {
    validationRules () {
      return this.expressionResolver(this.config.validation)
    }
  },
  methods: {
    onBlur () {}
  }
}
